import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Bandeaux/img-hero2-modified.png")